import * as Types from "../globalTypes.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ViewerQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ViewerQuery = {
  viewer: {
    currentUser:
      | {
          __typename: "Student";
          isDemo: boolean;
          id: string;
          email: string;
          name: string;
          type: string;
          hasAcceptedTos: boolean;
          isActive: boolean;
          defaultSession?: { id: string } | null;
          schools?: Array<{ id: string }> | null;
          teachers: Array<{
            id: string;
            name: string;
            profileImage?: { id: string; url: string } | null;
          }>;
          profileImage?: { id: string; url: string } | null;
        }
      | {
          __typename: "Teacher";
          hasSessions: boolean;
          numAllSessions: number;
          hasActiveStudents: boolean;
          hasDemoStudent: boolean;
          demoStudentNotificationCount: number;
          canHaveStudents: boolean;
          skipPreviewMode: boolean;
          emailVerificationStatus: Types.EmailVerificationStatus;
          id: string;
          email: string;
          name: string;
          type: string;
          hasAcceptedTos: boolean;
          isActive: boolean;
          school?: {
            id: string;
            name: string;
            canViewSchoolRoster: boolean;
            canViewSchoolDataDashboard: boolean;
            canReassignStudent: boolean;
          } | null;
          profileImage?: { id: string; url: string } | null;
        };
  };
};

export const ViewerDocument = gql`
  query Viewer {
    viewer {
      currentUser {
        __typename
        id
        email
        name
        type
        hasAcceptedTos
        isActive
        profileImage {
          id
          url(format: small_profile)
        }
        ... on Teacher {
          hasSessions
          numAllSessions
          hasActiveStudents
          hasDemoStudent
          demoStudentNotificationCount
          canHaveStudents
          skipPreviewMode
          emailVerificationStatus
          school {
            id
            name
            canViewSchoolRoster
            canViewSchoolDataDashboard
            canReassignStudent
          }
        }
        ... on Student {
          isDemo
          defaultSession {
            id
          }
          schools {
            id
          }
          teachers {
            id
            name
            profileImage {
              id
              url(format: small_profile)
            }
          }
        }
      }
    }
  }
`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options,
  );
}
export function useViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options,
  );
}
export function useViewerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ViewerQuery,
    ViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(
    ViewerDocument,
    options,
  );
}
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<
  typeof useViewerSuspenseQuery
>;
export type ViewerQueryResult = Apollo.QueryResult<
  ViewerQuery,
  ViewerQueryVariables
>;
